module.exports = __webpack_public_path__ + "static/media/longText.5974370b.svg";